import FormLoading from 'Components/FormLoading';
import Message from 'Components/Message';
import { RootState } from 'index';
import React from 'react';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { Table } from 'reactstrap';
import { queryKeyes } from 'shared/queryKeys';
import { Get } from 'VesselMaster/vesselMaster.hooks';

const SpeedAndConsumptionDisplay = ({ weatherCondtion }: { weatherCondtion: 'Fair' | 'All' }) => {
    const { VesselID } = useSelector((state: RootState) => state.Reporting);

    const {
        data: SpeedAndConsumption,
        isLoading: SpeedAndConsumptionLoading
    } = useQuery(
        [queryKeyes.vessel.SpeedAndConsumptionData.key, VesselID],
        async () => {
            return await Get(
                queryKeyes.vessel.SpeedAndConsumptionData.url(VesselID),
                VesselID
            );
        },
        {
            enabled: !!VesselID,
            staleTime: Infinity,
        }
    );

    if (SpeedAndConsumptionLoading) {
        return <FormLoading />
    }

    // Pick the correct dataset from API
    const data =
        SpeedAndConsumption?.[
        weatherCondtion === 'Fair' ? 'fair_weather' : 'all_weather'
        ] ?? [];

    return (
        <React.Fragment>
            <h4 className="mb-3">
                {weatherCondtion} Speed & Consumption Values
            </h4>
            <Table bordered responsive className="mb-0">
                <thead className="table-light">
                    <tr>
                        <th className="p-2 text-center align-middle">#</th>
                        <th className="p-2 text-center align-middle">
                            Vessel Speed (kt)
                        </th>
                        <th className="p-2 text-center align-middle">
                            Condition
                        </th>
                        <th className="p-2 text-center align-middle">
                            Power (kW)
                        </th>
                        <th className="p-2 text-center align-middle">
                            Fuel Consumption (mt/day)
                        </th>
                        <th className="p-2 text-center align-middle">
                            SFOC (g/kWh)
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center text-muted">
                                <Message message={'No data available'} type={'danger'} />
                            </td>
                        </tr>
                    ) : (
                        data.map((item: any, index: number) => (
                            <tr key={index}>
                                <td className="p-2 text-center align-middle">
                                    {index + 1}
                                </td>
                                <td className="p-2 text-center align-middle">
                                    {item.vessel_speed_sea_trail ?? '-'}
                                </td>
                                <td className="p-2 align-middle text-center">
                                    <div className="d-flex flex-column gap-2">
                                        <div>
                                            <b>Ballast</b>
                                        </div>
                                        <div className="mt-3">
                                            <b>Laden</b>
                                        </div>
                                    </div>
                                </td>
                                <td className="p-2 align-middle text-center">
                                    <div className="d-flex flex-column gap-2">
                                        <div className="text-muted">
                                            {item?.ballast?.avg_power ?? '-'}
                                        </div>
                                        <div className="text-muted mt-3">
                                            {item?.laden?.avg_power ?? '-'}
                                        </div>
                                    </div>
                                </td>
                                <td className="p-2 align-middle text-center">
                                    <div className="d-flex flex-column gap-2">
                                        <div className="text-muted">
                                            {item?.ballast?.avg_fc ?? '-'}
                                        </div>
                                        <div className="text-muted mt-3">
                                            {item?.laden?.avg_fc ?? '-'}
                                        </div>
                                    </div>
                                </td>
                                <td className="p-2 align-middle text-center">
                                    <div className="d-flex flex-column gap-2">
                                        <div className="text-muted">
                                            {item?.ballast?.sfoc ?? '-'}
                                        </div>
                                        <div className="text-muted mt-3">
                                            {item?.laden?.sfoc ?? '-'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
        </React.Fragment>
    );
};

export default SpeedAndConsumptionDisplay;
